module.exports = __webpack_public_path__ + "img/Insta-Bsp-03.413953d7.jpg";